export default function preloader(status, preloaderDOM) {
    if(!preloaderDOM) {
        return;
    }
    if(status === false) {
        preloaderDOM.classList.add('d-none');
    } else {
        preloaderDOM.classList.remove('d-none');
    }
}